import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 1. Import HelmetProvider
import { HelmetProvider } from 'react-helmet-async'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 2. Wrap the entire application in HelmetProvider */}
    <HelmetProvider> 
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();